import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChatBubble7: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chat-bubble-7"} maskId="square-filled-radius-0-stroke-1-IconChatBubble7"><path d="M12 2.5C17.497 2.5 22 6.72817 22 12C22 17.2718 17.497 21.5 12 21.5C10.2896 21.5 8.67776 21.0911 7.26758 20.3701C6.08672 20.6917 4.87038 20.8903 3.58594 20.9697L2.81055 21.0176L3.08887 20.292C3.43364 19.3914 3.721 18.4954 3.90918 17.582C2.71067 16.0167 2 14.0881 2 12C2 6.72817 6.50297 2.5 12 2.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChatBubble7;
